module.exports = __webpack_public_path__ + "media/images/company/cp04-228582686b8d9bc29120848e0c780a09.png";